import useFetch from '../hooks/useFetch';

const getVacaciones = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('empleado/getVacaciones', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getDatosCboSolicitud = async () => {   
  try {
    return await useFetch.fnGet('empleado/getCboSolicitudes');
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getSolicitudesEmpleado = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('empleado/getSolicitudesEmployee', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getSolicitudes = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('empleado/getSolicitudes', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const procesarSolicitud = async (dataRequest) => {
  try {
    return await useFetch.fnPost('empleado/procesarSolicitud', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const anularSolicitud = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('empleado/anularSolicitud', dataRequest);

  } catch (error) {
    console.error('Error API: ', error);
  }
}

const actualizarEstadoSolicitud = async (dataRequest) => {
  try {
    return await useFetch.fnPost('empleado/actualizarEstadoSolicitud', dataRequest);

  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getMarcaciones = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('empleado/getMarcacionesEmployee', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getEmpleadosMarcaciones = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('empleado/getEmpleadosMarcaciones', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getAllPerfiles = async (dataRequest) => {  
  try {
    return await useFetch.fnPost('empleado/getAllPerfiles', dataRequest);
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const getCargosDisponibles = async () => {   
  try {
    return await useFetch.fnGet('empleado/getCargosDisponibles');
  } catch (error) {
    console.error('Error API: ', error);
  }
}

const requestApi = {
  getVacaciones,
  getDatosCboSolicitud,
  getSolicitudesEmpleado,
  getSolicitudes,
  procesarSolicitud,
  anularSolicitud,
  actualizarEstadoSolicitud,
  getMarcaciones,
  getEmpleadosMarcaciones,
  getAllPerfiles,
  getCargosDisponibles
}

export default requestApi;